// sessionStorage.js
export const loadState = () => {
  try {
    const serializedState = sessionStorage.getItem('libra@User');
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

export const saveState = (state: any) => {
  try {
    const serializedState = JSON.stringify(state);
    sessionStorage.setItem('libra@User', serializedState);
  } catch {
    // ignore write errors
  }
};
